
import {FabricCollection} from './FabricCollection';
import {Fabric} from './Fabric';
import {FabricColor} from './FabricColor';
import {ProductCost} from './ProductCost';
import {TotalCost} from './TotalCost';

export class OrderItemProductFabricCollection {
  public id: number;
  public fabricsCollections: FabricCollection[] = [];
  public fabricCollection: number | FabricCollection;
  public fabricCollectionObj: FabricCollection;
  public fabrics: Fabric[] = [];
  public fabric: number | Fabric;
  public fabricObj: Fabric = new Fabric;
  public fabricColors: FabricColor[] = [];
  public fabricColor: number | FabricColor;
  public fabricColorObj: FabricColor;
  public totalCustomerPrice?: number;
  public totalDealerPrice?: number;
  public cost = new ProductCost();
  public totalCost = new TotalCost();
  public amount: number;
  public fabricName?: string;
  public fabricColorName?: string;
}
